/**
 * Double-submit CSRF support shared by every axios instance in the app.
 * The backend mints a non-httpOnly `csrf_token` cookie alongside the
 * session cookie; we read it here and echo it back as a header so the
 * server can confirm the request came from JS running on an allowed
 * origin (see middleware/authMiddleware.js `enforceCsrf` on the API).
 */
const CSRF_COOKIE_NAME = "csrf_token"
const CSRF_HEADER_NAME = "X-CSRF-Token"

export function getCsrfToken() {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${CSRF_COOKIE_NAME}=([^;]+)`))
    return match ? decodeURIComponent(match[1]) : null
}

/** Attaches the CSRF header to every outgoing request on the given axios instance. */
export function attachCsrfInterceptor(axiosInstance) {
    axiosInstance.interceptors.request.use((config) => {
        const token = getCsrfToken()
        if (token) {
            config.headers = config.headers || {}
            config.headers[CSRF_HEADER_NAME] = token
        }
        return config
    })
    return axiosInstance
}
